import styled from 'styled-components';

import StyledDefaultVariant from './StyledDefaultVariant';

export default styled(StyledDefaultVariant)`
	b {
		color: var(--cd-color);
	}
`;
